import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import moment from 'moment';

import {ConfigProvider, } from 'antd';
import 'moment/locale/zh-cn';
import { useTranslation } from 'react-i18next';
import { setshowDivsConditionsAuthorizedIP,setSelected ,setOpenDelete,setFilterAuthorizedIPActions,setAuthorizedIPDataActions} from "../../store/AuthorizedIPActions";
import { useAppSelector } from "../../../../Redux/hooks";
import UseActionMenu from "./actionsUserTable";
import Hooks from "../../utils/hooks"; 
import { useMediaQuery } from '@mui/material';
import { Datagrid } from '@empreinte/components.datagrid';
import frFR from 'antd/lib/locale/fr_FR';
import { GridNorows } from '@empreinte/components.grid-norows';

moment.locale('en');
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

function useDataTableMedia({ columns,  updateEntityPath }: any) {

    const { t } = useTranslation();
    const { handelFilter, handelSearch ,getListAuthorizedIP} = Hooks()

    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [selectedRow] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<any>(DEFAULT_PAGE_NUMBER);
    const [pageSize,setPageSize] = useState<any>(DEFAULT_PAGE_SIZE);
    const [locale] = useState<any>(frFR);
    const tabletColumn = useMediaQuery('(min-width:780px)');
    const mobileColumn = useMediaQuery('(min-width:550px)');
    // use Selector redux
    const List = useAppSelector((state) => state.AuthorizedIPReducer.List)
    /// add values 
    const values = useAppSelector((state) => state.AuthorizedIPReducer.filterAuthorizedIP)
    const unauthorizedUser = useAppSelector((state)=>state.ReducerUserData.unauthorizedUser)
  const totalength=useAppSelector((state)=>state.AuthorizedIPReducer.totalRecord)
  const searchWord = values.search
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(
            setshowDivsConditionsAuthorizedIP({
                showDivsConditionsName: "loader",
                showDivsConditionsValue: true,
             
            })
          )
        return ()=>{
            dispatch(
                setFilterAuthorizedIPActions({
                  FilterAuthorizedIPNameChange: "search",
                  FilterAuthorizedIPValueChange:''
                }) );
         dispatch(setAuthorizedIPDataActions([]))       
}
//eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        getListAuthorizedIP(currentPage,pageSize,searchWord)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPage,pageSize])


    useEffect(()=>{
        if(searchWord)
        setCurrentPage(1)
    //eslint-disable-next-line react-hooks/exhaustive-deps
        },[searchWord])
    useEffect(()=>{
        dispatch(
            setshowDivsConditionsAuthorizedIP({
                showDivsConditionsName: "loader",
                showDivsConditionsValue: true,
             
            })
          )
        return ()=>{
            dispatch(
                setFilterAuthorizedIPActions({
                  FilterAuthorizedIPNameChange: "search",
                  FilterAuthorizedIPValueChange:''
                }) );
         dispatch(setAuthorizedIPDataActions([]))       
}
//eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        getListAuthorizedIP(currentPage,pageSize,searchWord)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPage,pageSize,totalength,unauthorizedUser])


    useEffect(()=>{
        if(searchWord)
        setCurrentPage(1)
    //eslint-disable-next-line react-hooks/exhaustive-deps
        },[searchWord])

    const updatedColumns = [
        ...columns,
        {
            field:'Action',
            dataIndex:'action',
            key:3,
            flex:1,
            renderCell: (action: any, record: any) => (
                <UseActionMenu  record={action} />    
            )
            ,
            align: "center",
            width:100 ,
            sortable:false,
            

        },
    ];
    const filteredeventsfilter = handelFilter(values.type, List)
    const filteredevents = handelSearch(values.search, filteredeventsfilter)
    
    const resetPagination = () => {
        setCurrentPage(DEFAULT_PAGE_NUMBER);
    };

    function getFilteredEvents(filteredEvents:any, e:any) {
        let tab = filteredEvents.filter((item:any) => {
          return e.includes(item.id);
        });
        let newArray = Array.from(tab, (item:any) => {
          return item.id;
        });
        return newArray;
      }



    const DataTable = () => (
        <div className="DataTable">
            <ConfigProvider locale={locale}>
            {!filteredevents.length || !totalength ?
                <GridNorows  content={t('Zone.noRowsFound')} />
                :
                  <Datagrid
                className={"DataTable__custom-row"}
                height={"calc(90vh - 100px)"}
                columns={
                    tabletColumn
                      ? updatedColumns
                      : mobileColumn
                        ?  
                          updatedColumns.filter(
                            column =>
                              column.dataIndex !== 'ip' 
                          ):
                           updatedColumns.filter(
                            column =>
                              column.dataIndex !== 'ip' &&
                              column.dataIndex !== 'description'
                              
                          )
                  }
                totalEntities={totalength}
                selectionModel={selectedRowKeys}
                checkboxSelection={true}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                setPageSize={setPageSize}
                pageSize={pageSize}
                ShowName={t('boitier.AuthorizedIP.rows')}
                EntriesName={t('boitier.AuthorizedIP.element')}
                OfPageName={t('boitier.AuthorizedIP.of')}
                rows={List && filteredevents}
                checkboxSelect={e => {
                    let newArray = getFilteredEvents(filteredevents, e);
                    setSelectedRowKeys(e);
                    dispatch(setSelected(newArray));
                    dispatch(setOpenDelete(newArray.length > 0));
 
                    dispatch(setSelected(newArray));
                }}
                />
                }
            </ConfigProvider>
        </div>
    );

    return {
        DataTable,
        selectedRow,
        selectedRowKeys,
        currentPage,
        pageSize,
        resetPagination,
    };
}

export default useDataTableMedia;
